/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [
  {
    name: '留白',
    type: 'module-name',
  },
  {
    key: 'color',
    name: '颜色',
    type: 'color',
  },
  {
    key: 'margin_num',
    name: '左右边距',
    type: 'slider',
  },
  {
    key: 'radius_top',
    name: '上圆角',
    type: 'slider',
  },
  {
    key: 'radius_bottom',
    name: '下圆角',
    type: 'slider',
  },
  {
    key: 'height',
    name: '高度',
    type: 'height',
  },
];

export default config;
